<script setup>
import { computed } from 'vue';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';
import wootConstants from 'dashboard/constants/globals';

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  activeTab: {
    type: String,
    default: wootConstants.ASSIGNEE_TYPE.ME,
  },
});

const emit = defineEmits(['chatTabChange']);

const activeTabIndex = computed(() => {
  return props.items.findIndex(item => item.key === props.activeTab);
});

const onTabChange = selectedTabIndex => {
  if (selectedTabIndex >= 0 && selectedTabIndex < props.items.length) {
    const selectedItem = props.items[selectedTabIndex];
    if (selectedItem.key !== props.activeTab) {
      emit('chatTabChange', selectedItem.key);
    }
  }
};

const keyboardEvents = {
  'Alt+KeyN': {
    action: () => {
      if (props.activeTab === wootConstants.ASSIGNEE_TYPE.ALL) {
        onTabChange(0);
      } else {
        const nextIndex = (activeTabIndex.value + 1) % props.items.length;
        onTabChange(nextIndex);
      }
    },
  },
};

useKeyboardEvents(keyboardEvents);
</script>

<template>
  <div
    class="flex items-center gap-2 px-4 py-2.5 bg-background border-b border-n-weak select-none overflow-x-auto whitespace-nowrap scrollbar-none"
  >
    <button
      v-for="(item, index) in items"
      :key="item.key"
      class="flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-full border transition-all duration-200 w-full"
      :class="[
        activeTab === item.key
          ? 'bg-n-brand/10 text-n-brand border-n-brand/20 shadow-xs'
          : 'bg-n-alpha-1 text-n-slate-11 border-n-slate-3 dark:border-n-slate-4/10 hover:bg-n-alpha-2 hover:text-n-slate-12 hover:border-n-slate-4',
      ]"
      @click="onTabChange(index)"
    >
      <span class="w-full">{{ item.name }}</span>
      <span
        v-if="item.count !== undefined"
        class="flex items-center justify-center px-1.5 py-0.5 text-[10px] font-bold rounded-full transition-colors duration-200"
        :class="[
          activeTab === item.key
            ? 'bg-n-brand/20 text-n-brand'
            : 'bg-n-slate-3 text-n-slate-11 dark:bg-n-slate-8',
        ]"
      >
        {{ item.count }}
      </span>
    </button>
  </div>
</template>
